import { render, staticRenderFns } from "./OpenAIScore.vue?vue&type=template&id=8c3e7396&scoped=true"
import script from "./OpenAIScore.vue?vue&type=script&lang=js"
export * from "./OpenAIScore.vue?vue&type=script&lang=js"
import style0 from "./OpenAIScore.vue?vue&type=style&index=0&id=8c3e7396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3e7396",
  null
  
)

export default component.exports